module.exports = __webpack_public_path__ + "img/21.455f86ab.jpg";